/* CLEVERING — interacciones: anillo flotante, rayos X, historia con scroll, configurador, bento, tipografía reactiva y cursor anillo */
(function () {
  if (window.clScriptsInicializado) return;
  window.clScriptsInicializado = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function hex2rgb(h) {
    h = (h || '#ffffff').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
  }
  function vistaUnaVez(el, cb, th) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var o = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { cb(); o.disconnect(); }
    }, { threshold: th || 0.25 });
    o.observe(el);
  }

  /* 1) Portada: el anillo flota y se inclina con el cursor ---------------- */
  function initHero(root) {
    qsa(root, '[data-cl-hero]').forEach(function (hero) {
      if (hero.dataset.clListo) return; hero.dataset.clListo = '1';
      var escena = hero.querySelector('[data-cl-tilt]');
      if (!escena || reduce || !finePointer) return;
      var tx = 0, ty = 0, rx = 0, ry = 0, ox = 0, oy = 0, raf = null;
      function paso() {
        tx += (ox - tx) * 0.08; ty += (oy - ty) * 0.08;
        rx += ((-oy * 0.55) - rx) * 0.08; ry += ((ox * 0.7) - ry) * 0.08;
        escena.style.setProperty('--tx', tx.toFixed(2) + 'px');
        escena.style.setProperty('--ty', ty.toFixed(2) + 'px');
        escena.style.setProperty('--rx', rx.toFixed(2) + 'deg');
        escena.style.setProperty('--ry', ry.toFixed(2) + 'deg');
        if (Math.abs(ox - tx) > 0.05 || Math.abs(oy - ty) > 0.05 || Math.abs(rx) > 0.02 || Math.abs(ry) > 0.02) raf = requestAnimationFrame(paso);
        else raf = null;
      }
      function empujar() { if (!raf) raf = requestAnimationFrame(paso); }
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        ox = ((e.clientX - r.left) / r.width - 0.5) * 36;
        oy = ((e.clientY - r.top) / r.height - 0.5) * 26;
        empujar();
      });
      hero.addEventListener('pointerleave', function () { ox = 0; oy = 0; empujar(); });
    });
  }

  /* 2) Puntos interactivos sobre el anillo -------------------------------- */
  function initExplora(root) {
    qsa(root, '[data-cl-explora]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      var puntos = qsa(sec, '[data-cl-hs]'), items = qsa(sec, '[data-cl-hs-item]');
      if (!puntos.length) return;
      var actual = -1, pausadoHasta = 0, visible = false;
      function activar(i) {
        if (i === actual) return; actual = i;
        puntos.forEach(function (p, k) { var on = k === i; p.classList.toggle('is-activo', on); p.setAttribute('aria-expanded', on ? 'true' : 'false'); });
        items.forEach(function (it, k) { it.classList.toggle('is-activo', k === i); });
      }
      function usuario(i) { pausadoHasta = Date.now() + 9000; activar(i); }
      puntos.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { usuario(i); });
        p.addEventListener('focus', function () { usuario(i); });
        p.addEventListener('click', function (e) { e.preventDefault(); usuario(i); });
      });
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { usuario(i); });
        it.addEventListener('click', function () { usuario(i); });
        it.addEventListener('focus', function () { usuario(i); });
      });
      sec.addEventListener('mouseleave', function () { pausadoHasta = Date.now() + 2500; });
      activar(0);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.35 }).observe(sec);
      } else { visible = true; }
      window.setInterval(function () {
        if (!visible || Date.now() < pausadoHasta || reduce) return;
        activar((actual + 1) % puntos.length);
      }, 3600);
    });
  }

  /* 3) Lente de rayos X que sigue el cursor ------------------------------- */
  function initRayosX(root) {
    qsa(root, '[data-cl-rayosx]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      var stage = sec.querySelector('[data-cl-rx-stage]');
      var labels = qsa(sec, '[data-cl-rx-label]');
      if (!stage) return;
      var W = 1, H = 1, tx = 0.5, ty = 0.5, cx = 0.5, cy = 0.5, usuario = false, ultimo = 0, vis = false, t0 = performance.now();
      function medir() { var r = stage.getBoundingClientRect(); W = r.width; H = r.height; }
      medir(); window.addEventListener('resize', medir);
      function mover(e) {
        var r = stage.getBoundingClientRect();
        tx = clamp((e.clientX - r.left) / r.width, 0, 1);
        ty = clamp((e.clientY - r.top) / r.height, 0, 1);
        usuario = true; ultimo = performance.now();
        sec.classList.add('is-usuario');
      }
      stage.addEventListener('pointermove', mover);
      stage.addEventListener('pointerdown', mover);
      stage.addEventListener('pointerleave', function () { ultimo = performance.now(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { threshold: 0.1 }).observe(stage); else vis = true;
      function frame(t) {
        requestAnimationFrame(frame);
        if (!vis) return;
        if (!usuario || t - ultimo > 2600) {
          var s = (t - t0) / 1000;
          tx = 0.5 + Math.sin(s * 0.55) * 0.2; ty = 0.5 + Math.sin(s * 0.9 + 1) * 0.16;
          if (t - ultimo > 2600) sec.classList.remove('is-usuario');
        }
        cx = lerp(cx, tx, reduce ? 1 : 0.12); cy = lerp(cy, ty, reduce ? 1 : 0.12);
        stage.style.setProperty('--mx', (cx * W).toFixed(1) + 'px');
        stage.style.setProperty('--my', (cy * H).toFixed(1) + 'px');
        labels.forEach(function (l) {
          var lx = parseFloat(l.dataset.x) / 100, ly = parseFloat(l.dataset.y) / 100, lr = parseFloat(l.dataset.r || '14') / 100;
          var d = Math.sqrt(Math.pow((cx - lx) * W, 2) + Math.pow((cy - ly) * H, 2)) / W;
          l.classList.toggle('is-visible', d < lr);
        });
      }
      requestAnimationFrame(frame);
    });
  }

  /* 4) Historia pegada al scroll: un día con CLEVERING --------------------- */
  function initHistoria(root) {
    qsa(root, '[data-cl-historia]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      var caps = qsa(sec, '[data-cl-cap]');
      var dots = qsa(sec, '[data-cl-cap-dot]');
      var himgs = qsa(sec, '[data-cl-hist-img]');
      var n = caps.length; if (!n) return;
      var tonos = caps.map(function (c) { return hex2rgb(c.dataset.tono); });
      var arco = sec.querySelector('[data-cl-arco]');
      var circ = arco ? parseFloat(arco.getAttribute('data-circ')) : 0;
      var idxActual = -1, pend = false;
      function actualizar() {
        pend = false;
        var r = sec.getBoundingClientRect(), vh = window.innerHeight;
        var total = Math.max(1, r.height - vh);
        var p = clamp(-r.top / total, 0, 1);
        var f = p * (n - 1), a = Math.floor(f), b = Math.min(n - 1, a + 1), t = f - a;
        var c = [0, 1, 2].map(function (k) { return Math.round(lerp(tonos[a][k], tonos[b][k], t)); });
        sec.style.setProperty('--tono', 'rgb(' + c.join(',') + ')');
        sec.style.setProperty('--giro', (p * 360).toFixed(2) + 'deg');
        sec.style.setProperty('--prog', p.toFixed(4));
        if (arco) arco.style.strokeDashoffset = (circ * (1 - p)).toFixed(1);
        var idx = clamp(Math.round(f), 0, n - 1);
        if (idx !== idxActual) {
          idxActual = idx;
          caps.forEach(function (el, k) { el.classList.toggle('is-activo', k === idx); el.classList.toggle('is-pasado', k < idx); });
          dots.forEach(function (el, k) { el.classList.toggle('is-activo', k === idx); });
          himgs.forEach(function (el, k) { el.classList.toggle('is-activo', k === idx); });
        }
      }
      function pedir() { if (!pend) { pend = true; requestAnimationFrame(actualizar); } }
      window.addEventListener('scroll', pedir, { passive: true });
      window.addEventListener('resize', pedir);
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          var top = sec.getBoundingClientRect().top + window.scrollY;
          var total = sec.offsetHeight - window.innerHeight;
          window.scrollTo({ top: top + total * (i / Math.max(1, n - 1)) + 2, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      actualizar();
    });
  }

  /* 5) Tarjetas bento: inclinación 3D con brillo y animación al entrar ----- */
  function initBento(root) {
    qsa(root, '[data-cl-bento]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      qsa(sec, '[data-cl-card]').forEach(function (card) {
        vistaUnaVez(card, function () { card.classList.add('is-vista'); }, 0.3);
        if (reduce || !finePointer) return;
        card.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          card.style.setProperty('--ry', ((px - 0.5) * 9).toFixed(2) + 'deg');
          card.style.setProperty('--rx', ((0.5 - py) * 9).toFixed(2) + 'deg');
          card.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
          card.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        });
        card.addEventListener('pointerleave', function () {
          card.style.setProperty('--ry', '0deg'); card.style.setProperty('--rx', '0deg');
        });
      });
    });
  }

  /* 6) Configurador: acabado, medidor de dedo y compra directa ------------ */
  function initConfigurador(root) {
    qsa(root, '[data-cl-conf]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      var json = sec.querySelector('[data-cl-conf-json]');
      var variantes = [];
      try { variantes = JSON.parse(json.textContent); } catch (e) { variantes = []; }
      var tabs = qsa(sec, '[data-cl-acabado]'), imgs = qsa(sec, '[data-cl-conf-img]');
      var pills = qsa(sec, '[data-cl-talla]');
      var slider = sec.querySelector('[data-cl-medida]');
      var salidaMm = sec.querySelector('[data-cl-mm]'), salidaTalla = sec.querySelector('[data-cl-talla-rec]');
      var dedo = sec.querySelector('[data-cl-dedo]');
      var precio = sec.querySelector('[data-cl-precio]'), boton = sec.querySelector('[data-cl-comprar]'), msg = sec.querySelector('[data-cl-msg]');
      var nombreAc = sec.querySelector('[data-cl-nombre-acabado]');
      var tabla = { 7: 17.3, 8: 18.1, 9: 18.9, 10: 19.8, 11: 20.6, 12: 21.4, 13: 22.2 };
      var estado = { acabado: tabs.length ? tabs[0].dataset.clAcabado : '', talla: '9' };
      var manual = false;
      function mejor(mm) {
        var b = '9', d = 99;
        Object.keys(tabla).forEach(function (k) { var x = Math.abs(tabla[k] - mm); if (x < d) { d = x; b = k; } });
        return b;
      }
      function fmt(c) { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(c / 100); }
      function pintar() {
        tabs.forEach(function (t) { var on = t.dataset.clAcabado === estado.acabado; t.classList.toggle('is-activo', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); if (on && nombreAc) nombreAc.textContent = t.dataset.nombre || t.dataset.clAcabado; });
        imgs.forEach(function (im) { im.classList.toggle('is-activo', im.dataset.clConfImg === estado.acabado); });
        pills.forEach(function (p) { p.classList.toggle('is-activo', p.dataset.clTalla === estado.talla); });
        var v = variantes.filter(function (x) { return x.a === estado.acabado && String(x.t) === String(estado.talla); })[0];
        if (precio) precio.textContent = v ? fmt(v.p) : '';
        if (boton) {
          if (v && v.av) { boton.disabled = false; boton.textContent = boton.dataset.textoComprar || 'Añadir al carrito'; }
          else { boton.disabled = true; boton.textContent = boton.dataset.textoAgotado || 'Próximamente'; }
          boton.dataset.variante = v ? v.id : '';
        }
      }
      function medida() {
        var mm = parseFloat(slider.value);
        if (salidaMm) salidaMm.textContent = mm.toFixed(1).replace('.', ',') + ' mm';
        if (dedo) dedo.style.setProperty('--d', (mm * 7.2).toFixed(1) + 'px');
        if (!manual) estado.talla = mejor(mm);
        if (salidaTalla) salidaTalla.textContent = 'Talla ' + mejor(mm);
        pintar();
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { estado.acabado = t.dataset.clAcabado; pintar(); }); });
      pills.forEach(function (p) { p.addEventListener('click', function () { manual = true; estado.talla = p.dataset.clTalla; if (slider && tabla[estado.talla]) { slider.value = tabla[estado.talla]; if (salidaMm) salidaMm.textContent = tabla[estado.talla].toFixed(1).replace('.', ',') + ' mm'; if (dedo) dedo.style.setProperty('--d', (tabla[estado.talla] * 7.2).toFixed(1) + 'px'); if (salidaTalla) salidaTalla.textContent = 'Talla ' + estado.talla; } pintar(); }); });
      if (slider) slider.addEventListener('input', function () { manual = false; medida(); });
      if (boton) boton.addEventListener('click', function () {
        var id = boton.dataset.variante; if (!id || boton.disabled) return;
        boton.disabled = true; boton.classList.add('is-cargando');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
          .then(function () { boton.classList.remove('is-cargando'); boton.textContent = '¡Añadido! Ver carrito →'; boton.disabled = false; boton.dataset.variante = ''; boton.onclick = function () { window.location.href = '/cart'; }; if (msg) msg.textContent = ''; })
          .catch(function () { boton.classList.remove('is-cargando'); boton.disabled = false; if (msg) msg.textContent = 'No hemos podido añadirlo. Inténtalo de nuevo.'; pintar(); });
      });
      if (slider) medida(); else pintar();
    });
  }

  /* 7) Palabra gigante: las letras reaccionan al cursor -------------------- */
  function initTipografia(root) {
    qsa(root, '[data-cl-tipo]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      var letras = qsa(sec, '[data-cl-letra]');
      if (reduce || !finePointer || !letras.length) return;
      var px = -9999, py = -9999, raf = null;
      function pintar() {
        raf = null;
        letras.forEach(function (l) {
          var r = l.getBoundingClientRect();
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          var d = Math.sqrt(Math.pow(px - cx, 2) + Math.pow(py - cy, 2));
          var k = clamp(1 - d / 340, 0, 1);
          l.style.setProperty('--w', Math.round(300 + k * 400));
          l.style.setProperty('--y', (-k * 14).toFixed(1) + 'px');
          l.style.setProperty('--o', (0.55 + k * 0.45).toFixed(2));
        });
      }
      sec.addEventListener('pointermove', function (e) { px = e.clientX; py = e.clientY; if (!raf) raf = requestAnimationFrame(pintar); });
      sec.addEventListener('pointerleave', function () { px = -9999; py = -9999; if (!raf) raf = requestAnimationFrame(pintar); });
    });
  }

  /* 8) Selector de color simple (compatibilidad) --------------------------- */
  function initColores(root) {
    qsa(root, '[data-cl-colores]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      var tabs = qsa(sec, '[data-cl-color-tab]'), imgs = qsa(sec, '[data-cl-color-img]');
      var nombre = sec.querySelector('[data-cl-color-nombre]'), texto = sec.querySelector('[data-cl-color-texto]');
      function elegir(i) {
        tabs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-activo', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-activo', k === i); });
        var t = tabs[i]; if (nombre && t) nombre.textContent = t.getAttribute('data-nombre') || ''; if (texto && t) texto.textContent = t.getAttribute('data-texto') || '';
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { elegir(i); }); });
      if (tabs.length) elegir(0);
    });
  }

  /* 9) Cursor con forma de anillo ----------------------------------------- */
  function initCursor() {
    if (!finePointer || reduce || document.getElementById('cl-cursor')) return;
    var c = document.createElement('div'); c.id = 'cl-cursor'; c.className = 'cl-cursor';
    c.innerHTML = '<span class="cl-cursor__aro"></span><span class="cl-cursor__punto"></span>';
    document.body.appendChild(c);
    var x = -100, y = -100, ax = -100, ay = -100, visible = false;
    document.addEventListener('pointermove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!visible) { visible = true; c.classList.add('is-on'); ax = x; ay = y; }
      var t = e.target.closest && e.target.closest('a, button, [role="button"], input, select, summary, [data-cl-hs], [data-cl-card], label');
      c.classList.toggle('is-hover', !!t);
    });
    document.addEventListener('pointerdown', function () { c.classList.add('is-click'); });
    document.addEventListener('pointerup', function () { c.classList.remove('is-click'); });
    document.documentElement.addEventListener('mouseleave', function () { c.classList.remove('is-on'); visible = false; });
    (function loop() {
      ax = lerp(ax, x, 0.18); ay = lerp(ay, y, 0.18);
      c.style.transform = 'translate3d(' + ax.toFixed(1) + 'px,' + ay.toFixed(1) + 'px,0)';
      c.firstChild.style.transform = '';
      requestAnimationFrame(loop);
    })();
  }


  /* 9) Página de compra del anillo ----------------------------------------- */
  function initComprar(root) {
    qsa(root, '[data-cl-comprar-sec]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      var variantes = [];
      try { variantes = JSON.parse(sec.querySelector('[data-cl-cp-json]').textContent); } catch (e) {}
      var escena = sec.querySelector('[data-cl-cp-escena]');
      var capas = qsa(sec, '[data-cl-cp-capa]'), minis = qsa(sec, '[data-cl-cp-mini]');
      var acs = qsa(sec, '[data-cl-cp-acabado]'), tallas = qsa(sec, '[data-cl-cp-talla]');
      var etiqueta = sec.querySelector('[data-cl-cp-etiqueta]'), nomAc = sec.querySelector('[data-cl-cp-nombre-acabado]'), nomTa = sec.querySelector('[data-cl-cp-nombre-talla]');
      var precio = sec.querySelector('[data-cl-cp-precio]'), total = sec.querySelector('[data-cl-cp-total]');
      var boton = sec.querySelector('[data-cl-cp-boton]'), botonTxt = sec.querySelector('[data-cl-cp-boton-txt]'), msg = sec.querySelector('[data-cl-cp-msg]');
      var qtyEl = sec.querySelector('[data-cl-cp-qty]'), chip = sec.querySelector('[data-cl-cp-estado]');
      var barra = sec.querySelector('[data-cl-cp-barra]'), barraBtn = sec.querySelector('[data-cl-cp-barra-boton]'), barraTxt = sec.querySelector('[data-cl-cp-barra-txt]');
      var barraPrecio = sec.querySelector('[data-cl-cp-barra-precio]'), resumen = sec.querySelector('[data-cl-cp-resumen]');
      var medirBtn = sec.querySelector('[data-cl-cp-medir-btn]'), medir = sec.querySelector('[data-cl-cp-medir]');
      var slider = sec.querySelector('[data-cl-cp-slider]'), dedo = sec.querySelector('[data-cl-cp-dedo]');
      var tabla = { 7: 17.3, 8: 18.1, 9: 18.9, 10: 19.8, 11: 20.6, 12: 21.4, 13: 22.2 };
      var primero = acs.length ? acs[0].dataset.clCpAcabado : '';
      var primeraVista = minis.length ? minis[0].dataset.clCpMini : primero;
      var estado = { acabado: primero, talla: '', vista: primeraVista, qty: 1, dto: 0 };
      var packs = qsa(sec, '[data-cl-cp-pack]');
      var precioMostrado = 0, anim = null;
      function fmt(c) { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(c / 100); }
      function mejor(mm) { var b = '9', d = 99; Object.keys(tabla).forEach(function (k) { var x = Math.abs(tabla[k] - mm); if (x < d) { d = x; b = k; } }); return b; }
      function variante(a, t) { return variantes.filter(function (x) { return x.a === a && String(x.t) === String(t); })[0]; }
      function cuenta(el, hasta) {
        if (!el) return;
        if (reduce) { el.textContent = fmt(hasta); return; }
        var desde = parseFloat(el.dataset.v || hasta), t0 = null;
        el.dataset.v = hasta;
        if (desde === hasta) { el.textContent = fmt(hasta); return; }
        (function paso(ts) { if (!t0) t0 = ts; var k = clamp((ts - t0) / 450, 0, 1), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(desde + (hasta - desde) * e); if (k < 1) requestAnimationFrame(paso); })(performance.now());
      }
      function fechas() {
        var mn = parseInt(sec.dataset.diasMin, 10) || 7, mx = parseInt(sec.dataset.diasMax, 10) || 14;
        function f(n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }); }
        var a = sec.querySelector('[data-cl-cp-f1]'), b = sec.querySelector('[data-cl-cp-f2]');
        if (a) a.textContent = 'en 1-2 días';
        var et = sec.querySelector('[data-cl-cp-entrega-txt]'); if (et) et.textContent = mn === mx ? 'Recíbelo el ' + f(mn) : 'Recíbelo entre el ' + f(mn) + ' y el ' + f(mx);
        if (b) b.textContent = f(mn) + ' – ' + f(mx);
      }
      function pintar() {
        capas.forEach(function (c) { c.classList.toggle('is-activo', c.dataset.clCpCapa === estado.vista); });
        minis.forEach(function (m) { m.classList.toggle('is-activo', m.dataset.clCpMini === estado.vista); });
        var nombreVista = '';
        minis.forEach(function (m) { if (m.dataset.clCpMini === estado.vista) nombreVista = m.dataset.nombre || ''; });
        if (etiqueta) etiqueta.textContent = nombreVista;
        acs.forEach(function (a) { var on = a.dataset.clCpAcabado === estado.acabado; a.classList.toggle('is-activo', on); a.setAttribute('aria-pressed', on ? 'true' : 'false'); if (on && nomAc) nomAc.textContent = a.dataset.nombre || ''; });
        tallas.forEach(function (t) {
          var on = t.dataset.clCpTalla === estado.talla; t.classList.toggle('is-activo', on); t.setAttribute('aria-pressed', on ? 'true' : 'false');
          var v = variante(estado.acabado, t.dataset.clCpTalla); t.classList.toggle('is-agotada', !!v && !v.av);
        });
        if (nomTa) nomTa.textContent = estado.talla ? 'Talla ' + estado.talla : 'Elige tu talla';
        var v = estado.talla ? variante(estado.acabado, estado.talla) : null;
        var base = v ? v.p : (variantes.length ? Math.min.apply(null, variantes.map(function (x) { return x.p; })) : 0);
        var bruto = base * estado.qty, neto = Math.round(bruto * (1 - estado.dto / 100));
        var cmp = v && v.c && v.c > v.p ? v.c : 0;
        var tach = sec.querySelector('[data-cl-cp-tachado]'), aho = sec.querySelector('[data-cl-cp-ahorro]'), btach = sec.querySelector('[data-cl-cp-boton-tachado]');
        if (tach) { tach.hidden = !cmp; if (cmp) tach.textContent = fmt(cmp); }
        if (aho) { aho.hidden = !cmp; if (cmp) aho.textContent = 'AHORRA ' + Math.round((1 - v.p / cmp) * 100) + '%'; }
        if (btach) { var refb = cmp ? cmp * estado.qty : (estado.dto > 0 ? bruto : 0); btach.hidden = !refb; if (refb) btach.textContent = fmt(refb); }
        cuenta(precio, base); cuenta(total, neto); if (barraPrecio) barraPrecio.textContent = fmt(neto);
        packs.forEach(function (pk) {
          var q = parseInt(pk.dataset.qty, 10) || 1, d = parseFloat(pk.dataset.dto) || 0;
          var b = base * q, n = Math.round(b * (1 - d / 100));
          var t = pk.querySelector('[data-cl-cp-pack-total]'), ta = pk.querySelector('[data-cl-cp-pack-tachado]'), ah = pk.querySelector('[data-cl-cp-pack-ahorro]');
          if (t) t.textContent = fmt(n);
          if (ta) { ta.hidden = !(d > 0); if (d > 0) ta.textContent = fmt(b); }
          if (ah) { ah.hidden = !(d > 0); if (d > 0) ah.textContent = 'AHORRAS ' + fmt(b - n); }
        });
        if (qtyEl) qtyEl.textContent = estado.qty;
        var algunaDisp = variantes.some(function (x) { return x.av; });
        if (chip) { chip.classList.toggle('is-agotado', !algunaDisp); }
        boton.classList.remove('is-pendiente', 'is-agotado', 'is-ok');
        var txt;
        if (!estado.talla) { boton.classList.add('is-pendiente'); txt = 'Elige tu talla'; }
        else if (!v || !v.av) { boton.classList.add('is-agotado'); txt = boton.dataset.textoAgotado || 'Próximamente'; }
        else txt = boton.dataset.textoComprar || 'Añadir al carrito';
        if (botonTxt) botonTxt.textContent = txt; if (barraTxt) barraTxt.textContent = txt;
        boton.dataset.variante = v && v.av ? v.id : '';
        if (resumen) resumen.textContent = (nomAc ? nomAc.textContent : '') + (estado.talla ? ' · Talla ' + estado.talla : ' · Elige tu talla');
      }
      function fijarSlider(t) { var mm = tabla[t]; if (!slider || !mm) return; slider.value = mm; mm1(mm); }
      function mm1(mm) {
        var o = sec.querySelector('[data-cl-cp-mm]'), r = sec.querySelector('[data-cl-cp-rec]');
        if (o) o.textContent = mm.toFixed(1).replace('.', ',') + ' mm';
        if (dedo) dedo.style.setProperty('--d', (mm * 7.2).toFixed(1) + 'px');
        if (r) r.textContent = 'Talla ' + mejor(mm);
      }
      acs.forEach(function (a) { a.addEventListener('click', function () { estado.acabado = a.dataset.clCpAcabado; if (capas.some(function (c) { return c.dataset.clCpCapa === estado.acabado; })) estado.vista = estado.acabado; pintar(); }); });
      minis.forEach(function (m) { m.addEventListener('click', function () { estado.vista = m.dataset.clCpMini; if (m.dataset.acabado) estado.acabado = m.dataset.acabado; pintar(); }); });
      tallas.forEach(function (t) { t.addEventListener('click', function () { estado.talla = t.dataset.clCpTalla; fijarSlider(estado.talla); pintar(); }); });
      if (slider) slider.addEventListener('input', function () { var mm = parseFloat(slider.value); mm1(mm); estado.talla = mejor(mm); pintar(); });
      if (medirBtn && medir) medirBtn.addEventListener('click', function () { var ab = !medir.classList.contains('is-abierto'); medir.classList.toggle('is-abierto', ab); medirBtn.setAttribute('aria-expanded', ab ? 'true' : 'false'); });
      packs.forEach(function (pk, i) {
        pk.addEventListener('click', function () {
          estado.qty = parseInt(pk.dataset.qty, 10) || 1; estado.dto = parseFloat(pk.dataset.dto) || 0;
          packs.forEach(function (o) { var on = o === pk; o.classList.toggle('is-activo', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
          pintar();
        });
      });
      var menos = sec.querySelector('[data-cl-cp-menos]'), mas = sec.querySelector('[data-cl-cp-mas]');
      if (menos) menos.addEventListener('click', function () { estado.qty = Math.max(1, estado.qty - 1); pintar(); });
      if (mas) mas.addEventListener('click', function () { estado.qty = Math.min(5, estado.qty + 1); pintar(); });

      function comprar() {
        if (!estado.talla) {
          var g = sec.querySelector('[data-cl-cp-tallas]');
          if (g) { g.classList.remove('is-aviso'); void g.offsetWidth; g.classList.add('is-aviso'); g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
          if (medir && !medir.classList.contains('is-abierto')) { medir.classList.add('is-abierto'); if (medirBtn) medirBtn.setAttribute('aria-expanded', 'true'); }
          return;
        }
        var id = boton.dataset.variante; if (!id) return;
        boton.classList.add('is-cargando'); if (msg) msg.textContent = '';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: estado.qty }] }) })
          .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
          .then(function () {
            boton.classList.remove('is-cargando'); boton.classList.add('is-ok');
            if (botonTxt) botonTxt.textContent = '¡Añadido! Ver carrito →'; if (barraTxt) barraTxt.textContent = 'Ver carrito →';
            boton.dataset.variante = ''; boton.dataset.ok = '1'; barraBtn.dataset.ok = '1';
          })
          .catch(function () { boton.classList.remove('is-cargando'); if (msg) msg.textContent = 'No hemos podido añadirlo. Inténtalo de nuevo.'; pintar(); });
      }
      function pulsar() { if (boton.dataset.ok === '1') { window.location.href = '/cart'; return; } if (boton.classList.contains('is-agotado')) return; comprar(); }
      boton.addEventListener('click', pulsar);
      if (barraBtn) barraBtn.addEventListener('click', pulsar);

      /* barra fija: aparece cuando el botón principal sale de la pantalla */
      if (barra && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          var fuera = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
          barra.classList.toggle('is-visible', fuera); barra.setAttribute('aria-hidden', fuera ? 'false' : 'true');
          if (barraBtn) barraBtn.tabIndex = fuera ? 0 : -1;
        }, { threshold: 0 });
        io.observe(boton);
      }
      /* entrega: línea que se rellena al verse */
      var ent = sec.querySelector('[data-cl-cp-entrega]');
      if (ent) vistaUnaVez(ent, function () { ent.classList.add('is-vista'); }, 0.4);

      /* escenario: el anillo se inclina y flota con el cursor */
      if (escena && !reduce && finePointer) {
        escena.addEventListener('pointermove', function (e) {
          var r = escena.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          escena.classList.add('is-mov', 'is-visto');
          capas.forEach(function (c) {
            c.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 14).toFixed(2) + 'deg');
            c.style.setProperty('--px', (x * 16).toFixed(1) + 'px'); c.style.setProperty('--py', (y * 16).toFixed(1) + 'px');
          });
        });
        escena.addEventListener('pointerleave', function () {
          escena.classList.remove('is-mov');
          capas.forEach(function (c) { ['--ry', '--rx', '--px', '--py'].forEach(function (k) { c.style.setProperty(k, '0'); }); });
        });
      }

      /* guía de tallas */
      var guia = sec.querySelector('[data-cl-cp-guia]');
      if (guia) {
        var abrirG = sec.querySelector('[data-cl-cp-guia-abrir]'), antes = null;
        var circ = qsa(guia, '[data-cl-cp-guia-talla]'), filas = qsa(guia, '[data-cl-cp-guia-fila]');
        circ.forEach(function (c) { c.style.setProperty('--mm', c.dataset.mm); });
        function marcarG() {
          circ.forEach(function (c) { c.classList.toggle('is-activo', c.dataset.clCpGuiaTalla === estado.talla); });
          filas.forEach(function (f) { f.classList.toggle('is-activo', f.dataset.clCpGuiaFila === estado.talla); });
        }
        function abrir() { marcarG(); guia.hidden = false; document.documentElement.style.overflow = 'hidden'; antes = document.activeElement; var x = guia.querySelector('.cl-cp__modal-x'); if (x) x.focus(); }
        function cerrar() { guia.hidden = true; document.documentElement.style.overflow = ''; if (antes && antes.focus) antes.focus(); }
        if (abrirG) abrirG.addEventListener('click', abrir);
        qsa(guia, '[data-cl-cp-guia-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !guia.hidden) cerrar(); });
        qsa(guia, '[data-cl-cp-guia-elegir]').forEach(function (b) {
          b.addEventListener('click', function () { estado.talla = b.dataset.clCpGuiaElegir; fijarSlider(estado.talla); pintar(); marcarG(); setTimeout(cerrar, 350); });
        });
        var mbtn = sec.querySelector('[data-cl-cp-medir-btn]');
        if (mbtn) mbtn.addEventListener('click', function () { /* el medidor sigue disponible aparte */ });
      }
      fechas(); mm1(parseFloat(slider ? slider.value : 18.9)); pintar();
    });
  }


  /* 10) Contacto: al pasar el cursor por una pregunta se rellena el mensaje -- */
  function initContacto(root) {
    qsa(root, '[data-cl-contacto]').forEach(function (sec) {
      if (sec.dataset.clListo) return; sec.dataset.clListo = '1';
      var asunto = sec.querySelector('[data-cl-ct-asunto]'), mensaje = sec.querySelector('[data-cl-ct-mensaje]'), aviso = sec.querySelector('[data-cl-ct-auto]');
      if (!asunto || !mensaje) return;
      var tecleado = false, timer = null, actual = null;
      [asunto, mensaje].forEach(function (c) { c.addEventListener('input', function () { tecleado = true; c.classList.remove('is-auto'); if (aviso) aviso.classList.remove('is-visible'); }); });
      function escribir(el, texto, fin) {
        clearInterval(timer);
        if (reduce) { el.value = texto; if (fin) fin(); return; }
        var i = 0, paso = Math.max(1, Math.ceil(texto.length / 38));
        el.value = '';
        timer = setInterval(function () { i += paso; el.value = texto.slice(0, i); if (i >= texto.length) { clearInterval(timer); if (fin) fin(); } }, 18);
      }
      function rellenar(q) {
        if (tecleado || actual === q) return; actual = q;
        asunto.classList.add('is-auto'); mensaje.classList.add('is-auto');
        asunto.value = q.dataset.asunto || '';
        escribir(mensaje, q.dataset.mensaje || '');
        if (aviso) { aviso.textContent = 'Mensaje preparado: complétalo y envíalo'; aviso.classList.add('is-visible'); }
      }
      qsa(sec, '[data-cl-ct-q]').forEach(function (q) {
        q.addEventListener('mouseenter', function () { if (finePointer) rellenar(q); });
        q.addEventListener('focus', function () { rellenar(q); });
        q.addEventListener('click', function () { qsa(sec, '[data-cl-ct-q]').forEach(function (o) { o.classList.toggle('is-activo', o === q && !finePointer); }); rellenar(q); });
        q.addEventListener('keydown', function (e) { if (e.key === 'Enter') rellenar(q); });
      });
    });
  }

  /* 11) Suscripción 5%: envío sin recargar y código al instante ------------ */
  function initNews(root) {
    qsa(root, '[data-cl-news]').forEach(function (caja) {
      if (caja.dataset.clListo) return; caja.dataset.clListo = '1';
      var form = caja.querySelector('[data-cl-news-form]'); if (!form) return;
      var ok = caja.querySelector('[data-cl-news-ok]'), cajaForm = caja.querySelector('[data-cl-news-form-caja]'), err = caja.querySelector('[data-cl-news-error]');
      var codigoEl = caja.querySelector('[data-cl-codigo]'), copiar = caja.querySelector('[data-cl-copiar]');
      form.addEventListener('submit', function (e) {
        e.preventDefault(); if (err) err.textContent = '';
        form.classList.add('is-cargando');
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' }, redirect: 'follow' })
          .then(function (r) {
            if (r.url && r.url.indexOf('challenge') > -1) { form.submit(); return; }
            if (!r.ok) throw new Error('x');
            form.classList.remove('is-cargando');
            try { localStorage.setItem('cl_bv_ok', '1'); } catch (x) {}
            var cod = codigoEl ? codigoEl.textContent.trim() : '';
            if (cod) fetch('/discount/' + encodeURIComponent(cod), { credentials: 'same-origin' }).catch(function () {});
            if (cajaForm) cajaForm.hidden = true; if (ok) ok.hidden = false;
            document.dispatchEvent(new CustomEvent('cl:suscrito'));
          })
          .catch(function () { form.classList.remove('is-cargando'); if (err) err.textContent = 'No hemos podido suscribirte. Revisa el email e inténtalo de nuevo.'; });
      });
      if (copiar && codigoEl) copiar.addEventListener('click', function () {
        var t = codigoEl.textContent.trim();
        function listo() { copiar.textContent = '¡Copiado!'; setTimeout(function () { copiar.textContent = 'Copiar'; }, 1800); }
        if (navigator.clipboard) navigator.clipboard.writeText(t).then(listo, listo); else listo();
      });
    });
  }

  /* 12) Ventana de bienvenida: un anillo llega rodando y se hace grande ---- */
  function initBienvenida(root) {
    qsa(root, '[data-cl-bv]').forEach(function (bv) {
      if (bv.dataset.clListo) return; bv.dataset.clListo = '1';
      var tab = document.querySelector('[data-cl-bv-abrir]'), caja = bv.querySelector('.cl-bv__caja'), aro = bv.querySelector('.cl-bv__aro');
      var dias = parseInt(bv.dataset.dias, 10) || 3, retraso = (parseInt(bv.dataset.retraso, 10) || 7) * 1000;
      var abierto = false, lanzado = false;
      function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
      var suscrito = ls('cl_bv_ok') === '1';
      function cerrar() {
        if (!abierto) return; abierto = false;
        bv.classList.remove('is-abierto'); document.documentElement.style.overflow = '';
        setTimeout(function () { bv.hidden = true; bv.classList.remove('is-rueda'); }, 500);
        if (!suscrito) ls('cl_bv_cerrado', String(Date.now()));
        if (tab) tab.hidden = false;
      }
      function abrir() {
        if (abierto) return; abierto = true; lanzado = true;
        if (tab) tab.hidden = true;
        bv.hidden = false; document.documentElement.style.overflow = 'hidden';
        bv.classList.remove('is-abierto', 'is-rueda'); void bv.offsetWidth;
        if (reduce) { bv.classList.add('is-abierto'); return; }
        bv.classList.add('is-rueda');
        setTimeout(function () {
          var r = aro.getBoundingClientRect(), c = caja.getBoundingClientRect();
          caja.style.setProperty('--ox', (r.left + r.width / 2 - c.left).toFixed(0) + 'px');
          caja.style.setProperty('--oy', (r.top + r.height / 2 - c.top).toFixed(0) + 'px');
          bv.classList.add('is-abierto');
        }, 1550);
      }
      qsa(bv, '[data-cl-bv-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
      if (tab) tab.addEventListener('click', abrir);
      document.addEventListener('cl:suscrito', function () { suscrito = true; });
      var p = location.pathname;
      var excluida = /\/(cart|checkouts?|account|challenge)/.test(p) || document.body.classList.contains('template-password') || (window.Shopify && window.Shopify.designMode);
      if (excluida) { if (/\?cl_bv=1/.test(location.search)) abrir(); return; }
      if (suscrito) return;
      var cerradoEn = parseInt(ls('cl_bv_cerrado') || '0', 10);
      var reciente = cerradoEn && (Date.now() - cerradoEn) < dias * 86400000;
      if (reciente) { if (tab) tab.hidden = false; return; }
      setTimeout(function () { if (!lanzado) abrir(); }, retraso);
      if (finePointer) document.addEventListener('mouseout', function (e) { if (!lanzado && !e.relatedTarget && e.clientY < 8) abrir(); });
    });
  }

  function todo(root) {
    initHero(root); initExplora(root); initRayosX(root); initHistoria(root); initBento(root);
    initConfigurador(root); initTipografia(root); initColores(root); initComprar(root);
    initContacto(root); initNews(root); initBienvenida(root);
  }
  ready(function () { todo(document); });
  document.addEventListener('shopify:section:load', function (e) { todo(e.target); });
})();
